var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right mt-4 mr-4"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v("mdi-"+_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }